<template>
  <div>
    <v-card>
      <v-container>
        <v-row no-gutters class="d-flex align-center">
          <v-col cols="12" md="9">
            <v-btn class="info" small @click="openAddDialog">
              <v-icon small left>mdi-plus</v-icon>
              {{ $t("newCollaborator") }}
            </v-btn>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon v-on="on" v-bind="attrs" class="ml-2" color="primary">
                  mdi-information-outline
                </v-icon>
              </template>
              <span>{{ $t("collaboratorTooltip") }}</span>
            </v-tooltip>
          </v-col>
          <v-col cols="12" md="3">
            <v-text-field
              :class="$vuetify.breakpoint.smAndDown ? 'mt-3' : ''"
              v-model="search"
              append-icon="mdi-magnify"
              label="Pesquisar"
              single-line
              hide-details
              dense
              solo-inverted
              clearable
            ></v-text-field>
          </v-col>
        </v-row>
      </v-container>
      <v-data-table
        :headers="headers"
        :items="items"
        :search="search"
        :items-per-page="-1"
      >
        <template v-slot:item.id_usuario="{ item }">
          <v-btn @click="$copy(item.id_usuario)" x-small>{{
            item.id_usuario
          }}</v-btn>
        </template>

        <template v-slot:item.status="{ item }">
          <v-icon small :color="handleColorStatus(item.status)"
            >mdi-circle</v-icon
          >
        </template>
        <template v-slot:item.actions="{ item }">
          <v-btn-toggle>
            <v-btn small @click="openEditDialog(item)">
              <v-icon small>mdi-pencil</v-icon>
            </v-btn>

            <v-menu offset-y left>
              <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" v-on="on" small>
                  <v-icon small>mdi-dots-horizontal</v-icon>
                </v-btn>
              </template>
              <v-list dense outlined>
                <v-list-item-group>
                  <v-list-item
                    v-for="(active, i) in itemsActivation"
                    :key="i"
                    :disabled="item.status == active.value"
                    @click="setStatus(item.id_usuario, active.value)"
                  >
                    <v-list-item-action>
                      <v-icon small :color="handleColorStatus(active.value)"
                        >mdi-circle</v-icon
                      >
                    </v-list-item-action>
                    <v-list-item-title>
                      {{ active.text }}
                    </v-list-item-title>
                  </v-list-item>
                </v-list-item-group>
              </v-list>
            </v-menu>
          </v-btn-toggle>
        </template>
      </v-data-table>
    </v-card>
    <router-view></router-view>
  </div>
</template>
<script>
export default {
  name: "views-backoffice-users-list",
  data: () => ({
    dialog: false,
    search: "",
    items: [],
  }),

  computed: {
    headers() {
      return [
        {
          text: this.$t("idUser"),
          value: "id_usuario",
        },
        {
          text: this.$t("labelLogin"),
          value: "login",
        },
        {
          text: this.$t("name"),
          value: "nome",
        },
        {
          text: this.$t("status"),
          value: "status",
          sortable: false,
        },
        {
          text: this.$t("group"),
          value: "group_name",
        },
        {
          text: this.$t("actions"),
          value: "actions",
          align: "center",
          sortable: false,
        },
      ];
    },
    // items do Menu Ações
    itemsActivation() {
      return [
        { text: this.$t("activate"), value: 1 },
        { text: this.$t("supend"), value: 0 },
      ];
    },
    refresh() {
      return this.$store.state.refresh;
    },
    status() {
      return this.$store.state.filters.selectStatus.status;
    },
    saveFilters() {
      return this.$store.state.filters.save;
    },
    getDialogState() {
      return this.$store.state.showDialog;
    },
  },

  mounted() {
    this.listCollaborators();
  },

  watch: {
    saveFilters(val) {
      val && this.listCollaborators();
    },
    // Atualiza o dataTable quando fecha a Dialog Novo Colaborador ou Editar colaborador
    refresh(val) {
      val && this.listCollaborators();
      this.$store.commit("setRefresh", false);
    },
    status(val) {
      console.log(val);
    },
  },
  methods: {
    listCollaborators() {
      const body = {
        status: this.status,
      };
      this.$axios
        .post("administrator/colab/listUsers", this.$formdata(body))
        .then((response) => {
          if (response.status === 200) {
            this.items = response.data.dados;
            // Inverte o array, fazendo os últimos colaboradores cadastrados
            // aparecem em primeiro na lista
            this.items.reverse();
          }
        })
        .catch((response) => {
          if (!response.length) {
            this.items = [];
          }
        });
    },
    openAddDialog() {
      this.$router.push({ name: "AdministratorCreateCollaborator" });
      this.$store.commit("showDialog", true);
    },
    openEditDialog({ id_usuario, group_id }) {
      this.$router.push({
        name: "AdministratorEditCollaborator",
        query: {
          id_usuario,
          group_id,
          status: this.status,
        },
      });

      this.$store.commit("showDialog", true);
    },
    setStatus(id_usuario, value) {
      let body = {
        id_user: id_usuario,
        value: value,
      };
      this.$axios
        .post("administrator/colab/changeUser", this.$formdata(body))
        .then((response) => {
          if (response.status === 200) {
            this.$store.commit("setFeedbackSnack", {
              msg: response.data.messages,
              color: "success",
            });
          }
        })
        .finally(() => {
          this.listCollaborators();
        });
    },
    handleColorStatus(status) {
      if (status == 1) return "green";
      if (status == 2) return "orange";
      if (status == 0) return "red";
      if (status == 6) return "grey";
    },
  },
};
</script>
